import React from "react"
import { createPortal } from "react-dom"

// modalView: string [small, medium]
// title: string
// target: render target
// cssModifyer string modal css modificator
// enterNumber
export default function Modal({
  modalView,
  title,
  target = null,
  cssModifyer,
  onRequestClose,
  children,
}) {
  const handleModalClose = (e) => {
    if (typeof onRequestClose !== "function") return
    e.stopPropagation()
    if (!e.target.closest(".modal-content") || e.target.classList.contains("js-close")) {
      onRequestClose()
    }
  }

  switch (modalView) {
    case "xs":
      return (
        <>
          {createPortal(
            <div
              className={`modal modal-small small2 modal-${cssModifyer}`}
              style={{ display: "block" }}
              onClick={handleModalClose}
            >
              <div className="modal__zoom">
                <div className="modal-content">
                  <div className="close-btn js-close" onClick={handleModalClose} />
                  <div className="modal__content">
                    <div className="modal__title">{title}</div>
                    <div className="modal__content">{children}</div>
                  </div>
                </div>
              </div>
            </div>,
            target || document.querySelector("body"),
          )}
        </>
      )

    default:
      return <div>Modal</div>
  }
}
